import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sqzl",
  "use": "icon-sqzl-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-sqzl\"><defs><style type=\"text/css\"></style></defs><path d=\"M580.352 245.504L784 41.856l203.648 203.648-203.648 203.648-203.648-203.648zM128 128v256h256V128H128zM64 64h384v384H64V64z m576 576v256h256v-256h-256zM576 576h384v384H576V576z m-448 64v256h256v-256H128zM64 576h384v384H64V576z\" p-id=\"8931\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol